
export enum PaymentEnum {
    PayStack,
    PayAtHouse
}